import AxiosInstance from "../AxiosSetting/axios"


const Fetcher =  (urlMethod,urlAPI,urlBody) => AxiosInstance({
    method  : urlMethod,
    url     : urlAPI,
    data    : urlBody,
    headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("token"),
     }
})

export default Fetcher